module.exports = __webpack_public_path__ + "static/media/recipe.35df353c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/recipe.jpg
// module id = 29
// module chunks = 0